import React from 'react';
import { Link } from 'react-router-dom';
import { Icon } from '../icons/Icon';
import { withAuth0 } from '@auth0/auth0-react';
import { connect } from 'react-redux';

/**
 * A simplified header component that includes the navigation links but avoids
 * the complex components that cause navigation issues
 */
const SimplifiedHeader = ({ auth0, priceAlerts, lists, favourites, basket }) => {
  const { isAuthenticated, user } = auth0;
  
  // Get counter values from props - for desktop view only
  const priceAlertsCount = priceAlerts?.priceAlerts?.length || 0;
  const listsCount = lists?.lists?.length || 0;
  const favouritesCount = favourites?.favourites?.length || 0;
  
  // Determine if it's mobile view
  const isMobile = typeof window !== 'undefined' && window.innerWidth < 768;

  // Mobile header view
  if (isMobile) {
    return (
      <div className="u-background--magenta">
        <div className="u-flex u-justify-center u-align-center u-pv--12">
          <a href="/">
            <Icon id="longlogo" width="175px" height="34px" />
          </a>
        </div>
      </div>
    );
  }
  
  // Desktop header view
  return (
    <div className="u-background--magenta">
      <div className="u-w-all u-flex u-justify-between u-pv--24 u-pl--20 u-br--bottomleft--large u-align-center u-ph--12">
        <div className="u-ph--4">
          <a href="/">
            <Icon id="longlogo" width="175px" height="34px" />
          </a>
        </div>
        
        <div className="u-flex u-w-all u-main-font--vsmall u-align-center u-justify-end">
          {/* Navigation links on the left */}
          <div className="u-flex u-align-center u-border--right--white u-pv--8 u-ph--12">
            {/* Social Media Button */}
            <div className="u-cursor--pointer u-flex u-align-center">
              <Link to={{ pathname: "https://www.facebook.com/Grocerize/" }} target="_blank" className="u-ph--8">
                <Icon id="facebook" fill="#ffffff" />
              </Link>
              <Link to={{ pathname: "https://www.instagram.com/grocerize/?hl=en" }} target="_blank" className="u-ph--8">
                <Icon id="instagram" fill="#ffffff" />
              </Link>
            </div>
            
            {/* Question Mark */}
            <div className="u-cursor--pointer u-flex u-align-center">
              <button className={"u-link u-color-white u-ph--12 u-semi-bold"}>
                <Icon id="question_mark_white" fill="transparent" size="xl" />
              </button>
            </div>
            
            {/* Pages Link */}
            {/* <a 
              href="/pages"
              className="u-cursor--pointer u-flex u-align-center"
            >
              <button
                className={"u-link u-color-white u-ph--12 u-semi-bold"}
                style={{ fontSize: "14px" }}
              >
                Pages
              </button>
            </a> */}
            
            {/* Recipes Link */}
            <a 
              href="/recipes"
              className="u-cursor--pointer u-flex u-align-center"
            >
              {/* <button
                className={"u-link u-color-white u-ph--12 u-semi-bold"}
                style={{ fontSize: "14px" }}
              >
                Recipes
              </button> */}
            </a>
          </div>
          
          {/* User information on the right - desktop view */}
          {isAuthenticated ? (
            <div className="u-color-white u-ph--16 u-semi-bold" style={{ fontSize: "14px" }}>
              <a href="/my/details">
                Hi {user?.name || 'Testing'}
              </a>
              <div className="u-flex u-pt--8">
                <a className="u-flex u-align-center u-w-all u-text-oneline" href="/my/alerts">
                  <div className="u-text-oneline u-pr--4">Price alerts</div>
                  <div className="u-br--all u-background--white u-color-magenta u-flex u-justify-center u-align-center" style={{ width: "26px", height: "26px" }}>
                    {priceAlertsCount}
                  </div>
                </a>

                <a className="u-flex u-align-center u-pl--32 u-w-all u-text-oneline" href="/my/lists">
                  <div className="u-ph--4 u-text-oneline">My Lists</div>
                  <div className="u-br--all u-background--white u-color-magenta u-flex u-justify-center u-align-center" style={{ width: "26px", height: "26px" }}>
                    {listsCount}
                  </div>
                </a>

                <a className="u-flex u-align-center u-pl--32 u-w-all u-text-oneline" href="/my/favourites">
                  <div className="u-ph--4 u-text-oneline">Favourites</div>
                  <div className="u-br--all u-background--white u-color-magenta u-flex u-justify-center u-align-center" style={{ width: "26px", height: "26px" }}>
                    {favouritesCount}
                  </div>
                </a>
              </div>
            </div>
          ) : (
            <div className="u-color-white u-ph--16 u-semi-bold" style={{ fontSize: "14px" }}>
              <a href="/auth/login" className="u-pr--12">Login</a>
              <a href="/auth/signup">Sign up</a>
            </div>
          )}
        </div>
        
        {/* User information for mobile - under the header */}
        <div className="u-hide--desktop u-w-all u-background--magenta u-pt--8 u-pb--12 u-ph--12">
          {isAuthenticated ? (
            <div className="u-color-white u-w-all u-flex u-justify-between">
              <div className="u-semi-bold">
                Hi {user?.email || 'testgrocerize50@gmail.com'}
              </div>
              <div className="u-flex">
                <a className="u-flex u-align-center u-text-oneline" href="/my/alerts">
                  <div className="u-text-oneline">Price alerts</div>
                  <div className="u-ml--8 u-br--all u-background--white u-color-magenta u-flex u-justify-center u-align-center" style={{ width: "24px", height: "24px" }}>
                    {priceAlertsCount}
                  </div>
                </a>

                <a className="u-flex u-align-center u-ml--16 u-text-oneline" href="/my/lists">
                  <div className="u-text-oneline">My Lists</div>
                  <div className="u-ml--8 u-br--all u-background--white u-color-magenta u-flex u-justify-center u-align-center" style={{ width: "24px", height: "24px" }}>
                    {listsCount}
                  </div>
                </a>

                <a className="u-flex u-align-center u-ml--16 u-text-oneline" href="/my/favourites">
                  <div className="u-text-oneline">Favourites</div>
                  <div className="u-ml--8 u-br--all u-background--white u-color-magenta u-flex u-justify-center u-align-center" style={{ width: "24px", height: "24px" }}>
                    {favouritesCount}
                  </div>
                </a>
              </div>
            </div>
          ) : (
            <div className="u-color-white u-ph--16 u-semi-bold u-flex u-justify-end">
              <a href="/auth/login" className="u-pr--12">Login</a>
              <a href="/auth/signup">Sign up</a>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

const mapStateToProps = (state) => ({
  lists: state.lists || {},
  favourites: state.favourites || {},
  priceAlerts: state.priceAlerts || {},
  basket: state.basket || {}
});

export default withAuth0(connect(mapStateToProps)(SimplifiedHeader));
